var _g, _g2, _g3, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 79,
    viewBox: "0 0 204 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_256_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.196 0C137.887 0.472962 138.651 0.836779 139.379 1.27336C141.707 2.5831 144.035 3.89284 146.364 5.20258C147.237 5.71192 148.147 6.18489 149.02 6.69423C149.893 7.16719 150.111 8.00397 150.22 8.91351C150.257 9.09542 150.22 9.24095 150.22 9.42286C150.22 27.6137 150.22 45.8045 150.22 63.9954C150.22 65.4506 149.675 66.433 148.438 67.1242C145.818 68.6159 143.199 70.1439 140.579 71.6355C137.632 73.3455 134.722 75.019 131.775 76.729C131.084 77.1292 130.356 77.5658 129.665 77.966C128.864 78.4025 128.064 78.5117 127.263 78.0387C125.59 77.0928 123.953 76.1469 122.279 75.2009C120.933 74.4369 119.587 73.6365 118.204 72.8725C115.367 71.2353 112.565 69.5982 109.728 67.961C109 67.5244 108.272 67.1242 107.545 66.6876C106.853 66.2874 106.562 65.6326 106.526 64.8322C106.49 64.3228 106.526 63.8135 106.526 63.3041C106.526 56.4644 106.526 49.6246 106.526 42.7849C106.526 41.5115 106.963 40.602 108.127 39.9835C110.601 38.601 113.038 37.1457 115.512 35.7268C118.459 34.0169 121.37 32.3433 124.317 30.6334C125.263 30.0877 126.208 29.5419 127.154 28.9962C127.846 28.596 128.61 28.5232 129.337 28.8871C130.429 29.4692 131.484 30.0877 132.539 30.7061C133.157 31.07 133.776 31.4338 134.431 31.7612C135.013 32.0523 135.631 31.6884 135.668 31.0336C135.668 30.8517 135.668 30.6698 135.668 30.4879C135.668 21.065 135.668 11.6058 135.668 2.1829C135.668 1.3825 135.522 0.545725 136.359 0.0363817C136.614 0 136.905 0 137.196 0ZM135.522 53.4447C135.522 52.3896 135.486 51.2982 135.522 50.2431C135.559 49.4791 135.304 49.0789 134.649 48.7151C132.684 47.66 130.72 46.4958 128.792 45.368C128.464 45.1861 128.173 45.1861 127.809 45.368C125.699 46.6049 123.553 47.8055 121.442 49.0061C121.151 49.1517 121.079 49.4063 121.079 49.6974C121.079 52.1713 121.079 54.6817 121.079 57.1556C121.079 57.5194 121.224 57.7377 121.515 57.9196C123.407 59.0111 125.335 60.1025 127.227 61.194C128.61 61.9944 128.428 61.7761 129.483 61.1576C131.338 60.1025 133.194 59.0111 135.049 57.956C135.413 57.7377 135.559 57.4831 135.559 57.0465C135.486 55.8459 135.522 54.6453 135.522 53.4447Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bii_256_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0363817 41.0386C0.254672 40.9295 0.254672 40.6748 0.327435 40.4929C0.65487 39.838 1.27336 39.547 1.81908 39.2195C3.74731 38.0917 5.71192 37.0003 7.64015 35.8724C10.296 34.3444 12.9519 32.8164 15.6077 31.2883C17.2449 30.3424 18.9185 29.3965 20.5557 28.4506C21.5016 27.9048 22.4475 28.014 23.357 28.5233C25.1397 29.542 26.9224 30.5971 28.7051 31.6158C31.2519 33.071 33.7622 34.5263 36.3089 35.9816C38.3463 37.1458 40.42 38.31 42.4574 39.5106C43.2578 39.9836 43.6216 40.7112 43.6216 41.6935C43.5853 49.2973 43.6216 56.9374 43.5853 64.5412C43.5853 66.8696 43.5489 69.1981 43.5853 71.5265C43.6216 72.7271 42.5666 73.2 41.6206 72.6543C38.892 71.0899 36.127 69.4891 33.3984 67.9247C32.3797 67.3426 31.3974 66.7605 30.4151 66.1784C29.6147 65.7054 29.1781 65.0505 29.1781 64.0682C29.1781 59.4841 29.1781 54.9 29.1781 50.3523C29.1781 49.9158 29.069 49.4792 28.9234 49.079C28.7051 48.4969 28.2686 48.1331 27.7592 47.842C26.1948 46.9325 24.6304 46.0229 23.066 45.1498C22.302 44.7132 21.4652 44.7132 20.7012 45.1498C19.0276 46.0957 17.3541 47.0052 15.7169 47.9875C14.9893 48.4241 14.5891 49.1154 14.5891 49.9885C14.5891 54.5726 14.5891 59.1567 14.5891 63.7772C14.5891 64.9414 14.0797 65.7418 13.0974 66.3239C9.9322 68.1066 6.76699 69.9257 3.60179 71.7448C3.05606 72.0722 2.51034 72.3633 1.92823 72.6907C1.12783 73.0909 0.618489 72.9454 0.145527 72.1813C0.109145 72.1086 0.0363817 72.0722 0 72.0358C0.0363817 61.7034 0.0363817 51.371 0.0363817 41.0386Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bii_256_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.446 47.8056C203.373 47.8419 203.3 47.9147 203.3 47.9875C203.118 48.7151 202.609 49.1881 201.954 49.5519C198.825 51.371 195.697 53.1901 192.568 55.0091C191.986 55.3366 191.367 55.6276 190.821 55.9914C189.621 56.7555 188.711 55.9914 188.711 54.7909C188.711 53.5903 188.711 52.3533 188.711 51.1527C188.711 50.6433 188.675 50.134 188.711 49.6246C188.748 49.1153 188.493 48.7515 188.056 48.5332C186.128 47.4054 184.164 46.3139 182.235 45.1861C181.653 44.8587 181.18 44.895 180.635 45.2589C179.288 46.0592 177.906 46.8233 176.56 47.6237C175.978 47.9511 175.359 48.3149 174.777 48.6787C174.45 48.8606 174.268 49.1517 174.268 49.5519C174.268 51.9531 174.268 54.3907 174.268 56.7918C174.268 57.3376 174.595 57.5922 174.995 57.8469C177.215 59.1203 179.434 60.3572 181.617 61.6306C184.455 63.2678 187.329 64.905 190.167 66.5785C191.549 67.3789 192.968 68.1793 194.314 68.9797C195.224 69.5254 195.151 70.5441 194.241 71.0898C192.677 71.963 191.076 72.8362 189.512 73.7093C187.292 74.9463 185.037 76.2197 182.817 77.4566C181.835 78.0024 180.926 77.8568 179.98 77.3111C178.015 76.1469 176.014 75.0191 174.013 73.8912C171.321 72.3632 168.629 70.8352 165.936 69.2708C164.299 68.3248 162.626 67.4153 160.988 66.433C160.261 65.9964 159.824 65.3052 159.824 64.432C159.824 56.901 159.824 49.4064 159.824 41.8754C159.824 40.9658 160.261 40.3109 161.025 39.8744C163.535 38.4191 166.045 37.0002 168.519 35.5813C171.466 33.9078 174.377 32.1978 177.324 30.4879C178.306 29.9058 179.288 29.3601 180.271 28.7779C181.18 28.2322 182.053 28.2322 182.999 28.7779C186.055 30.597 189.148 32.3434 192.24 34.1261C195.078 35.7632 197.879 37.4004 200.717 39.0376C201.19 39.3286 201.663 39.5833 202.136 39.8744C202.609 40.1654 202.937 40.5656 203.155 41.075C203.191 41.1841 203.228 41.3296 203.373 41.366C203.446 43.5125 203.446 45.659 203.446 47.8056Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.8116 53.2628C96.8116 56.719 96.7752 60.1753 96.8479 63.6315C96.8843 65.0868 96.3386 66.0691 95.0652 66.724C93.1734 67.7427 91.3543 68.8341 89.4988 69.9256C87.5706 71.0534 85.6424 72.1085 83.7141 73.2363C81.6404 74.4369 79.5666 75.6739 77.4929 76.8745C77.0563 77.1292 76.6561 77.3838 76.2195 77.6021C75.3464 77.9659 74.4732 77.8568 73.6728 77.3838C70.8714 75.783 68.1064 74.1459 65.305 72.5451C62.5764 70.9807 59.8841 69.4162 57.1555 67.8154C56.3187 67.3425 55.5183 66.8695 54.6816 66.3966C53.8812 65.9236 53.4082 65.2323 53.4082 64.25C53.4082 56.7918 53.4082 49.3699 53.4082 41.9117C53.4082 40.8202 54.0267 40.1654 54.8635 39.656C56.7189 38.5282 58.6108 37.4731 60.5026 36.3817C62.54 35.2175 64.6138 34.0169 66.6511 32.8526C68.543 31.7612 70.4348 30.7061 72.3267 29.6147C72.9452 29.2509 73.5273 28.8143 74.1821 28.5596C74.9098 28.2686 75.6374 28.3049 76.2923 28.7051C79.2028 30.3787 82.1497 31.9795 85.0239 33.7258C86.2609 34.4898 87.4978 35.1811 88.7348 35.9451C89.9718 36.7091 91.2452 37.3276 92.4821 38.0916C92.9915 38.3827 93.4644 38.6737 93.9738 38.9648C94.4468 39.2194 94.9197 39.4741 95.4291 39.7288C96.375 40.2381 96.7752 41.0385 96.7752 42.0208C96.8116 45.8409 96.8116 49.5518 96.8116 53.2628Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.838 53.0447C185.838 53.6995 185.801 54.3544 185.838 55.0093C185.874 55.3731 185.656 55.5914 185.401 55.7369C184.237 56.3918 183.073 57.0466 181.945 57.7015C181.727 57.8107 181.581 57.8107 181.363 57.7015C180.199 57.0466 179.034 56.3918 177.87 55.7369C177.543 55.555 177.434 55.3003 177.434 54.9729C177.434 53.6995 177.434 52.4262 177.434 51.1528C177.434 50.4616 178.016 50.316 178.452 50.0614C179.362 49.5156 180.308 49.0063 181.254 48.4606C181.508 48.315 181.727 48.2787 182.018 48.4606C183.146 49.1154 184.273 49.7339 185.438 50.3888C185.729 50.5707 185.911 50.789 185.874 51.1528C185.801 51.7713 185.838 52.4262 185.838 53.0447Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_256_12",
    x: 102.51,
    y: -4,
    width: 51.7266,
    height: 86.3467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_256_12"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_256_12",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_256_12"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_256_12",
    result: "effect3_innerShadow_256_12"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bii_256_12",
    x: -4,
    y: 24.0884,
    width: 51.6211,
    height: 52.8188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_256_12"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_256_12",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_256_12"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_256_12",
    result: "effect3_innerShadow_256_12"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bii_256_12",
    x: 155.824,
    y: 24.3687,
    width: 51.6211,
    height: 57.4316,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_256_12"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_256_12",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_256_12"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_256_12",
    result: "effect3_innerShadow_256_12"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNode);
export default __webpack_public_path__ + "static/media/Node.e826cfc2f4d9b70783e7970f622b9006.svg";
export { ForwardRef as ReactComponent };